import Cookies from 'js-cookie';
import HttpClient from '../../HttpClient';
import {baseURL} from '../../url';

class Pallet extends HttpClient {

    constructor(Callback) {
        // const url = process.env.API_URL;

        super(Callback, {
            baseURL,
            headers: {},
            Callback,
        });
        this.setHeader('Content-Type', 'application/json');
        this.setHeader('Accept', 'application/json');
        this.setBearerAuth(`Bearer  ${Cookies.get('token')}`);

    }

    static request(Callback) {
        return new Pallet(Callback);
    }


    palletList() {
        return this.get('pallet');
    }

    getReport(apiAddress) {
        return this.get(apiAddress,{},true);
    }


    palletRow() {
        return this.get('pallet/row');
    }

    PrintQueue(id) {
        return this.put(`PrintQueue/${id}`);
    }


    palletConfused(id) {
        return this.put(`Pallet/confused?pid=${id}`);
    }


    numberPerPallet() {
        return this.put('Pallet/NumberPerPallet');
    }

    CanclePallet(id) {
        return this.put(`Pallet/CanclePallet?pid=${id}`);
    }

    createProduce(data) {
        return this.post(`Pallet/produce`, data);
    }


    createWarehouse(data) {
        return this.post(`Pallet/warehouse`, data);
    }


    updateWarehouse(data) {
        return this.put(`Pallet/warehouse`, data);
    }


    reconstruct(data) {
        return this.put(`Pallet/reconstruct`);
    }


    printPallet() {
        return this.post(`Pallet`);
    }

    LocationInfo() {
        return this.get(`Pallet/LocationInfo`);
    }


    palletQc(data) {
        return this.put(`Pallet/qc`, data);
    }


    palletWarehouseEntry(data) {
        return this.put(`Pallet/WarehouseEntry`, data);
    }


    palletOrder(id) {
        return this.post(`order/Pallets/${id}`);
    }

    editCreateOrder(method, data, id) {
        return this[method](`order/${id || ''}`, data);
    }





    createOrderDetail(id, data) {
        return this.post(`Order/Detail/${id}`, data);
    }

    deleteOrderDetail(id) {
        return this.delete(`Order/Detail/${id}`);
    }

    deleteOrderPallet(id) {
        return this.delete(`Order/pallets/${id}`);
    }

    getOrder() {
        return this.get(`Order`);
    }

    closeOrder(id) {
        return this.put(`Order/close/${id}`);
    }


    getOrderDetail(id) {
        return this.get(`Order/Detail/${id}`);
    }


    PalletTransaction() {
        return this.get(`Pallet/Transaction`);
    }


        orderList() {
        return this.get(`Order/List`);
    }


}

export default Pallet;
